import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx } from "@emotion/core";
import PropTypes from "prop-types";
import { useTheme } from "./Theme/Providers";
export var Divider = function Divider(_a) {
  var muted = _a.muted,
      other = tslib_1.__rest(_a, ["muted"]);

  var theme = useTheme();
  return jsx("div", tslib_1.__assign({
    className: "Divider",
    css: {
      borderTopColor: muted ? theme.colors.border.muted : theme.colors.border.default,
      display: "block",
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      margin: theme.spaces.md + " 0"
    }
  }, other));
};
Divider.propTypes = {
  muted: PropTypes.bool
};